import { Box, Flex, useMediaQuery, Text } from 'native-base';
import CommonDetailCard from '../../../containers/detailCard';
import { COMMONFONTSIZE } from '../../../utils/fonts';
import { MOBILE_VIEW_WIDTH } from '../../../utils/screens';

const HotelDetailsCard = ({ hotelData }) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH
  });

  // Handle case where hotelData might be null or undefined
  if (!hotelData) {
    return (
      <Box p={4}>
        <Text>No hotel data available</Text>
      </Box>
    );
  }

  // Helper function to get total dishes count
  const getTotalDishes = (dishes) => {
    if (!dishes) return 0;
    return Object.values(dishes).reduce((sum, count) => sum + (count || 0), 0);
  };

  // Convert hotel data to display format for CommonDetailCard
  const displayData = [
    { heading: 'Hotel Name', name: hotelData.hotel_name || '-' },
    { heading: 'Hotel Chain', name: hotelData.hotel_chain || '-' },
    { heading: 'City', name: hotelData.city || '-' },
    { heading: 'Hotel SPOC', name: hotelData.hotel_spoc || '-' },
    { heading: 'SPOC Email', name: hotelData.spoc_email || '-' },
    { heading: 'SPOC Phone', name: hotelData.spoc_number || '-' },
    { heading: 'Banquet Venue', name: hotelData.banquet_venue || '-' },
    { heading: 'Location', name: hotelData.location || '-' },
    { heading: 'Cluster', name: hotelData.cluster || '-' },
    { heading: 'Theatre', name: hotelData.theatre || '-' },
    { heading: 'Rate (₹)', name: hotelData.rate ? `₹${hotelData.rate}` : '-' },
    { heading: 'Dishes', name: `${getTotalDishes(hotelData.dishes)} items` },
    { heading: 'Remarks', name: hotelData.remarks || '-' }
  ];

  if (MobileWindow) {
    return (
      <div className='grid-container-2'>
        {displayData?.map((item, index) => (
          <div
            key={index}
            className='d-grid'
            style={{ marginBottom: '14px' }}
          >
            <CommonDetailCard
              heading={item.heading}
              text={item.name}
              headingSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
              textSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className='grid-container-3'>
      {displayData?.map((item, index) => (
        <div
          key={index}
          className='d-grid'
          style={{ marginBottom: '14px' }}
        >
          <CommonDetailCard
            heading={item.heading}
            text={item.name}
            headingSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
            textSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
          />
        </div>
      ))}
    </div>
  );
};

export default HotelDetailsCard;
